import type { BotActionFeedback } from './botControlActions'

/** Renders one B4 bot-control action's outcome (warning/error) inline, next
 * to the control that caused it — shared by `SettingsDefaultPage`,
 * `CoinSheetPage` and `OpenPositionsPage` so every button reports the same
 * way. `null` when there is nothing to show. */
export function BotActionNotice({ feedback }: { feedback: BotActionFeedback | undefined }) {
  if (!feedback) return null
  return (
    <p role={feedback.tone === 'error' ? 'alert' : 'status'} className={`portal-notice portal-notice--${feedback.tone}`}>
      {feedback.text}
    </p>
  )
}
